import '../../imports/jquery'
import '../../imports/datepicker-in-fullscreen/components/bootstrap-datepicker/bootstrap-datepicker.min.js'
// import 'expose-loader?locale!./imports/datepicker-in-fullscreen/components/bootstrap-datepicker/locales/bootstrap-datepicker.en-GB.min.js'
import 'expose-loader?moment!moment'
import 'jquery-touchswipe'
import '../../imports/datepicker-in-fullscreen/datepicker-in-fullscreen'

export default {
  bind: function (el, binding, vnode) {

    let options = {}

    if (binding.expression) {
      options = JSON.parse(binding.expression)
    }

    $(el).datepickerInFullscreen({
      fakeInput: false,
      format: 'dddd DD/MM/YYYY',
      todayWord: options.todayWord,
      template: `<div class="datepicker-in-fullscreen-modal">
                  <div class="datepicker-in-fullscreen-content">
                    <div class="datepicker-in-fullscreen"></div>
                    <div class="datepicker-in-fullscreen-controls">
                      <a class="dpifs-clear">{{clear}}</a><a class="dpifs-close">{{close}}</a>
                    </div>
                  </div>
                </div>
                <div class="datepicker-in-fullscreen-background"></div>`,
      datepicker: {
        startDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        weekStart: 1,
        datesDisabled: options.datesDisabled,
        todayHighlight: options.todayHighlight
      },
      onChange: function (modal, settings) {
        el.dispatchEvent(new Event('input'))
      }
    })
  },

  inserted: function (el) {}
}